import React from "react";

import Resource from "app/core/resource/";
import Strings from "app/core/utilites/strings";

class MassMedia extends React.Component {
    constructor(props) {
        super(props);

        /**
         * @property strings
         * @type {Strings}
         */
        this.strings = Strings.getInstance();

        /**
         * @property linksResource
         * @type {Object}
         */
        this.linksResource = Resource.links;

        /**
         * @property descriptionLength
         * @type {number}
         */
        this.descriptionLength = 102;

        this.articles = [
            {
                id: 1,
                title: "PaySpace Magazine",
                url: "https://psm7.com/e-commerce/kak-v-apteka24-ua-zapuskali-besplatnuyu-dostavku-lekarstv-na-dom-po-vsej-ukraine.html",
                description: "З початком карантину на apteka24.ua з'явилася безкоштовна доставка ліків у всі населені пункти України через кур'єрські служби. Завдяки співпраці з Укрпоштою, “Новою поштою” та Justin аптека зробила адресну доставку медичних товарів новим стандартом для країни. Редакція журналу PaySpace Magazine вирішила дізнатися, з чого все починалося та з якими складнощами довелося зіткнутися команді.",
                preview: this.linksResource.images.logo.rayspace
            },
            {
                id: 2,
                title: "PaySpace Magazine",
                url: "https://psm7.com/articles/kak-zakazat-lekarstva-onlajn-luchshie-servisy-dlya-dostavki-medikamentov.html",
                description: "Звичайно, доставка лікарських засобів зазвичай суворо обмежена або заборонена. Для українців це абсолютно новий варіант, який став доступним через пандемію коронавірусу та гостру необхідність максимальної самоізоляції.",
                preview: this.linksResource.images.logo.rayspace
            },
            {
                id: 3,
                title: "retailers.ua",
                url: "https://retailers.ua/news/partneryi/10327-apteka24ua-sovmestno-s-ukrpochtoy-zapustili-dostavku-lekarstv-na-dom-po-vsey-ukraine",
                description: "Інтернет-аптека apteka24 розширює доставку товарів по всій Україні. До кінця карантину 'Укрпошта' буде безкоштовно доставляти замовлення з доставкою на дім в маленькі міста та села.",
                preview: this.linksResource.images.logo.retailers
            },
            {
                id: 4,
                title: "fakty.com.ua",
                url: "https://fakty.com.ua/ua/ukraine/20200417-ukrposhta-bezkoshtovno-dostavlyatyme-liky-pid-chas-karantynu/",
                description: "Укрпошта безкоштовно доставлятиме ліки, замовлені на сайті інтернет-аптеки apteka24. Для того, щоб отримати безкоштовну доставку, потрібно зробити замовлення на сайті apteka24.ua і вибрати спосіб доставки – Укрпошта. Оплатити замовлення можна банківською карткою під час оформлення або готівкою при отриманні.",
                preview: this.linksResource.images.logo.facts
            },
            {
                id: 5,
                title: "itc.ua",
                url: "https://itc.ua/news/na-vremya-karantina-nova-poshta-budet-besplatno-dostavlyat-lekarstva-iz-apteka24-ua-po-adresu-v-pochtomat-ili-otdelenie/",
                description: "Сервіс «Нова пошта» та інтернет-аптека apteka24.ua запустили спільний проект з безкоштовної доставки ліків на період карантину. У результаті придбаний медикаменти та обладнання можна буде отримати прямо додому за допомогою кур'єрів.",
                preview: this.linksResource.images.logo.itc
            }
        ];
    }

    /**
     * @private
     * @method renderItems
     * @returns {Array}
     */
    renderItems() {
        let self = this;

        return this.articles.map(function (item) {
            return (
                <article
                    className="mass-media__item"
                    key={item.id}
                >
                    <a
                        href={item.url}
                        rel="noreferrer"
                        target="_blank"
                        className="item__preview"
                    >
                        <img src={item.preview} alt="Preview" />
                    </a>

                    <a
                        href={item.url}
                        rel="noreferrer"
                        target="_blank"
                        className="item__title"
                    >
                        { item.title }
                    </a>

                    <p
                        className="item__description"
                        title={item.description}
                    >
                        { self.strings.clip(item.description, self.descriptionLength) }
                        {/*{ item.description }*/}
                    </p>
                </article>
            );
        });
    }

    /**
     * @public
     * @method render
     * @returns {String}
     */
    render() {
        return (
            <div className="mass-media">
                <div className="mass-media__body">
                    <div className="mass-media__items">
                        { this.renderItems() }
                    </div>
                </div>
            </div>
        );
    }
}

export default MassMedia;
